export var DataExportScope;
(function (DataExportScope) {
    DataExportScope["PageView"] = "views";
    DataExportScope["Session"] = "sessions";
    DataExportScope["Invalid"] = "INVALID";
})(DataExportScope || (DataExportScope = {}));
//# sourceMappingURL=data-export.scope.js.map